import { useLazyQuery } from "@apollo/client/react";import { useEffect, useState } from "react";

import { GET_CONTRATOS_CONTROL_VISITAS } from '../../../data/graphQL/queries/ControlVisitas/getContratosControl';
import toast from "react-hot-toast";

export const useGetRows = (filters, applyClientSideFilters) => {
  const [rows, setRows] = useState([]);
  const [datosOriginales, setDatosOriginales] = useState([]);

  const [getContratos, { data: dataContratos, loading }] = useLazyQuery(GET_CONTRATOS_CONTROL_VISITAS, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataContratos) return;
    setRows(dataContratos?.controlVisitas);
    setDatosOriginales(dataContratos?.controlVisitas);
  }, [dataContratos]);

  const handleSearch = () => {
    getContratos({
      variables: {
        input: {
          estado: filters?.estado,
          idTipoProfesional: Number(filters?.idTipoProfesional) || null,
          idDelegacion: Number(filters?.idDelegacion) || null,
          mes: filters?.mes || null,
          anio: filters?.anio || null
        }
      }
    });
  };

  useEffect(() => {
    if (isNaN(filters.idDelegacion) || filters.idDelegacion === null) {
      setRows([]);
      toast.error('Por favor, selecciona una delegacion.');
    } else

    handleSearch();
  }, [filters]);

  useEffect(() => {
    const dataFiltered = applyClientSideFilters(datosOriginales, filters?.txtFiltro);
    setRows(dataFiltered);
  }, [datosOriginales, filters?.txtFiltro, filters?.estado]);

  return {
    rows,
    setRows,
    loading,
    totalCount: rows?.length || 0,
    handleSearch
  };
};